export default Object.freeze({
  Unset: {
    name: null,
    icon: 'fa fa-exchange-alt',
  },
  CambioDeEstatus: {
    id: 1,
    name: 'Cambio de Estatus',
    icon: 'fa fa-exchange-alt',
  },
  LogInterface: {
    id: 2,
    name: 'Log Interface',
    icon: 'fa fa-globe',
  },
});
